const NoStock = () => {
  return (
    <div className="absolute bg-orange-500 text-white px-10 py-2 text-xs top-0 -right-8 rotate-45	 translate-y-1/2 z-10">
      Agotado
    </div>
  );
};

export default NoStock;
